{
	"main": {
		"title": "Voli a vela",
		"subtitle1": "DATI DELL'AEREO A VELA",
		"subtitle2": "DATI DELL'AEREO TRAINO",
		"subtitle3": "DATI GENERALI",
		"nazaj": "Indietro"
	},
	"nav": {
		"vnos": "Inserimento",
		"zapisi": "Record"
	},
	"labels": {
		"pilotJ": "Seleziona il pilota dell'aereo a vela:",
		"instruktor": "Seleziona l'istruttore dell'aereo a vela:",
		"registracijaJ": "Seleziona reg. aereo a vela:",
		"namenJ": "Seleziona scopo:",
		"nalogaJ": "Seleziona compito del volo a vela:",
		"pilotM": "Seleziona il pilota dell'aereo traino:",
		"registracijaM": "Seleziona reg. aereo traino:",
		"vzlet": "Seleziona decollo:",
		"pristanek": "Seleziona atterraggio:",
		"poletanje": "Decollo:",
		"odklop": "Distacco:",
		"nezakljucen": "Volo non completato?",
		"pristanekJ": "Atterraggio dell'aereo a vela:",
		"pristanekM": "Atterraggio dell'aereo traino:",
		"opomba": "Nota",
		"novIcao": "inserire il codice ICAO",
		"dodajLetalisce": "Aggiungi un aeroporto",
		"opozorilo": "Per il traino, nel campo \"Decollo\" va indicato il momento in cui l’aereo si muove con l’intento di decollare con la fune di traino agganciata.\nNel campo \"Atterraggio dell’aereo da traino\", invece, va indicato il momento in cui l’aereo si ferma completamente dopo l’atterraggio."
	},
	"buttons": {
		"brisiIzbiro": "Cancella selezione",
		"vnesiZapis": "Inserisci record",
		"dodajLetalisce": "conferma"
	},
	"obvestila": {
	  "brisiSredstvo": "Sei sicuro di voler eliminare il bene?",
	  "vnosUspesen": "Inserimento effettuato con successo. Modifica di conseguenza il diario di bordo per questa registrazione.",
	  "vnosLetaliscaUspesen": "Inserimento effettuato con successo",
	  "vnosNeuspesen": "Errore nel recupero dei dati.",
	  "nepricakovanaNapaka": "Si è verificato un errore imprevisto",
	  "napakaBranja": "Errore nella lettura dei dati.",
	  "napakaBranjaNezakljuceni": "Errore nella lettura dei dati (voli non conclusi).",
	  "napakaBranjaCasVleke": "Errore nella lettura dei dati (tempo di traino).",
	  "poslano": "Messaggio inviato",
	  "niPoslano": "Il messaggio non è stato inviato",
	  "zapisPrihodnost": "Il record contiene una data futura. CORREGGI la data selezionata!",
	  "zapisCasPrihodnost": "Uno o più record contengono un’ora futura. Controlla gli orari!",
	  "zapisCasNapaka": "Gli orari dei record non sono corretti! Controlla di nuovo!",
	  "zapisDodan": "Record aggiunto con successo!  Modifica di conseguenza il diario di bordo per questa registrazione.",
	  "zapisNapaka": "Errore nell’inserimento dei dati",
	  "zapisNapakaMotorno": "Errore nell’inserimento dei dati (traino a motore).",
	  "napakaInputa": "Errore di inserimento. I campi contrassegnati in rosso sono obbligatori! Controlla che tutti i campi siano compilati!",
	  "napakaDodajanjaLetalisca": "Si è verificato un errore durante l'inserimento dell'aeroporto",
	  "letalisceNiNajdeno": "Il codice ICAO dell'aeroporto non è presente nel database"
	}
}